import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23fe4962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-card" }
const _hoisted_2 = {
  key: 0,
  id: "photoAndConstruction",
  class: "section page-card__content"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  id: "passport",
  class: "section page-card__content"
}
const _hoisted_5 = {
  key: 0,
  class: "mt--27"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-font-size mb--10" }, "Описание", -1))
const _hoisted_7 = {
  id: "map",
  class: "section page-card__content page-card__map"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--10" }, "На карте", -1))
const _hoisted_9 = {
  key: 0,
  class: "mb--10"
}
const _hoisted_10 = {
  key: 1,
  id: "documentation",
  class: "section page-card__content"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Документация", -1))
const _hoisted_12 = {
  id: "aboutDeveloper",
  class: "section page-card__content"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "О Застройщике", -1))
const _hoisted_14 = {
  id: "ads",
  class: "section page-card__content"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Все объявления ЖК", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "pb--10 pt--10 center" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "page-card__grid-cards" }
const _hoisted_20 = { class: "center mt--20" }
const _hoisted_21 = {
  key: 2,
  class: "page-card__content"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Иные проекты застройщика", -1))
const _hoisted_23 = {
  key: 0,
  class: "page-card__grid-cards"
}
const _hoisted_24 = {
  key: 1,
  class: "page-card__grid-cards"
}
const _hoisted_25 = { class: "page-card__aside" }
const _hoisted_26 = { class: "m-font-size mb--10 medium" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb--5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Сдача: "),
  /*#__PURE__*/_createElementVNode("span", null, "4 кв. 2026")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb--5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "От: "),
  /*#__PURE__*/_createElementVNode("span", null, "12 000 000 ₽")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Класс: "),
  /*#__PURE__*/_createElementVNode("span", null, "44")
], -1))
const _hoisted_30 = { class: "mt--25" }
const _hoisted_31 = { class: "mt--25" }
const _hoisted_32 = { class: "page-card__aside-mobile-card" }
const _hoisted_33 = { class: "page-card__menu" }
const _hoisted_34 = ["href", "onClick"]

import { computed, inject, onMounted, Ref, ref } from 'vue';
import {
  ActivityButtons,
  ImageModal,
  MenuBlock,
  PassportTable,
} from '../CardsComponents';
import {
  DeveloperSmallCard,
  DocumentList,
  MapBlock,
  PhoneButton,
  ResidentialComplexCard,
} from '@/components';
import { ResidentialComplexType, ResultCardType } from '@/types';
import { SmallCardLSDType } from '@/types/DeveloperTypes';
import LoadingResidentialComplexCard from '@/components/ResidentialComplexCard/LoadingResidentialComplexCard.vue';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';
import { useRoute, useRouter } from 'vue-router';
import { useAppStore } from '@/store/modules/app';
import { OfferSmallCard } from '@/components/Cards';
import { goToCard } from '@/utils/Cards/OfferCard';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResidentialComplexCard',
  props: {
    residentialComplexData: {},
    projectsLoading: { type: Boolean },
    projects: {},
    resultCards: {}
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();
const menuItems = [
  {
    id: 'photoAndConstruction',
    title: 'Фото и строительство',
  },
  {
    id: 'passport',
    title: 'Паспорт объекта',
  },
  {
    id: 'map',
    title: 'На карте',
  },
  {
    id: 'documentation',
    title: 'Документация',
  },
  {
    id: 'aboutDeveloper',
    title: 'О Застройщике',
  },
  {
    id: 'ads',
    title: 'Объявления ЖК',
  },
  // {
  //   id: 'news',
  //   title: 'Новости',
  // },
];
const filtersMap = [
  'Инфраструктура',
  'Цена аренды',
  'Цена продажи',
  'Окупаемость',
  'Транспорт',
  'Площадь',
];

const showImageModal = ref(false);
const showAllDescription = ref(false);
const showFurther = ref(false);
const imagesModal: Ref<string[]> = ref([]);
const visibleOffersCount = ref(4);

const description = computed((): string => {
  if (!props.residentialComplexData?.description) {
    return '-';
  }
  let sliced: string;

  sliced = props.residentialComplexData.description?.slice(0, 400);

  if (sliced?.length < props.residentialComplexData.description?.length) {
    showFurther.value = true;
  }

  return showAllDescription.value ? props.residentialComplexData.description : sliced;
});
const slidersGroups = computed(() => {
  const slidersGroups = [];

  if (props.residentialComplexData.logo) {
    slidersGroups.push({
      id: 1,
      title: 'Лого',
      slides: [props.residentialComplexData.logo],
    });
  }

  if (props.residentialComplexData.renders.length) {
    slidersGroups[0].slides = [
      ...slidersGroups[0].slides,
      ...props.residentialComplexData.renders,
    ];
  }

  return slidersGroups;
});

const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;

onMounted(() => {
  const hash = useRoute().hash;

  if (hash) {
    const myEl = document.getElementById(hash.replace('#', ''));

    if (myEl) {
      smoothScroll({
        scrollTo: myEl,
        container: myEl,
        updateHistory: true,
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_image_gallery = _resolveComponent("base-image-gallery")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_swiper = _resolveComponent("base-swiper")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_menu = _resolveComponent("base-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (slidersGroups.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_base_image_gallery, {
              "img-name": _ctx.residentialComplexData.title,
              "img-title": _ctx.residentialComplexData.title,
              "slides-group": slidersGroups.value,
              "space-between": 5
            }, {
              item: _withCtx((itemProps) => [
                _createElementVNode("button", {
                  class: "page-card__item-img-box",
                  onClick: ($event: any) => {
                showImageModal.value = true;
                imagesModal.value = itemProps.data.slides;
              }
                }, [
                  _createVNode(_component_base_image, {
                    name: _ctx.residentialComplexData.title,
                    src: itemProps.data.item,
                    title: _ctx.residentialComplexData.title,
                    "border-radius": "",
                    class: "page-card__item-img",
                    contain: "",
                    height: "100%",
                    width: "100%"
                  }, null, 8, ["name", "src", "title"])
                ], 8, _hoisted_3)
              ]),
              _: 1
            }, 8, ["img-name", "img-title", "slides-group"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(PassportTable), {
          tableData: [
            {
              title: 'ЖК',
              items: _ctx.residentialComplexData.passportLCItems,
            },
          ],
          class: "mt--27"
        }, null, 8, ["tableData"]),
        (_ctx.residentialComplexData.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(description.value || '-') + " ", 1),
                (showFurther.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "main-color underline",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllDescription.value = !showAllDescription.value))
                    }, _toDisplayString(showAllDescription.value ? 'Скрыть' : 'Далее'), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.residentialComplexData.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Адрес: " + _toDisplayString(_ctx.residentialComplexData.address), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_base_card, {
          "full-width-mobile": "",
          "without-mobile-shadow": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MapBlock), {
              "center-point-map": _ctx.residentialComplexData.coordinates[0]?.coordinates,
              "result-cards-coordinates": _ctx.residentialComplexData.coordinates,
              class: "mt--20",
              height: "370"
            }, null, 8, ["center-point-map", "result-cards-coordinates"])
          ]),
          _: 1
        })
      ]),
      (_ctx.residentialComplexData.documents?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", null, [
              _createVNode(_component_base_card, {
                class: "page-card__documentation",
                "full-width-mobile": "",
                "without-mobile-shadow": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DocumentList), {
                    documents: _ctx.residentialComplexData.documents
                  }, null, 8, ["documents"])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", null, [
          _createVNode(_unref(DeveloperSmallCard), {
            developer: _ctx.residentialComplexData.developer,
            "is-full": ""
          }, null, 8, ["developer"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        (_unref(useAppStore)().getWindowWidth() > 600)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_base_swiper, {
                slides: _ctx.resultCards,
                "space-between": 20,
                "width-item": 240,
                class: "mt--20 mb--20"
              }, {
                item: _withCtx((itemProps) => [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(OfferSmallCard), {
                      card: itemProps.data,
                      "without-scale": "",
                      onChangeActive: ($event: any) => (_unref(goToCard)(itemProps.data.landUrl))
                    }, null, 8, ["card", "onChangeActive"])
                  ])
                ]),
                _: 1
              }, 8, ["slides"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultCards?.slice(0, visibleOffersCount.value), (offerCard) => {
                  return (_openBlock(), _createBlock(_unref(OfferSmallCard), {
                    card: offerCard,
                    "without-scale": ""
                  }, null, 8, ["card"]))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.resultCards?.length > visibleOffersCount.value)
                  ? (_openBlock(), _createBlock(_component_base_button, {
                      key: 0,
                      height: "36",
                      text: "Показать еще",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (visibleOffersCount.value = visibleOffersCount.value + 4))
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      (_ctx.projectsLoading || _ctx.projects?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            (_ctx.projectsLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                    return _createVNode(LoadingResidentialComplexCard, { key: i })
                  }), 64))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, i) => {
                    return (_openBlock(), _createBlock(_unref(ResidentialComplexCard), {
                      key: i,
                      project: project,
                      version: "v1"
                    }, null, 8, ["project"]))
                  }), 128))
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_card, { class: "page-card__main-info" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.residentialComplexData.title), 1),
            _hoisted_27,
            _hoisted_28,
            _hoisted_29
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_base_card, null, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuBlock), { "menu-items": menuItems })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_base_card, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ActivityButtons), {
              docs: _ctx.residentialComplexData.presentation,
              phone: _ctx.residentialComplexData.phone
            }, null, 8, ["docs", "phone"])
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, {
      class: "page-card__aside-mobile mb--22",
      to: "#mobileDownMenu"
    }, [
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_unref(PhoneButton), {
          phone: _ctx.residentialComplexData.phone,
          "phone-modal": _unref(useAppStore)().getWindowWidth() <= 600,
          height: "36"
        }, null, 8, ["phone", "phone-modal"]),
        _createVNode(_component_base_menu, null, {
          menuItems: _withCtx((menuItemsProps) => [
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item, i) => {
                return _createElementVNode("div", {
                  key: item.id
                }, [
                  _createElementVNode("a", {
                    href: `#${item.id}`,
                    class: "page-card__menu-item",
                    onClick: ($event: any) => (menuItemsProps.events.handleClick())
                  }, _toDisplayString(item.title), 9, _hoisted_34),
                  (i !== menuItems.length - 1)
                    ? (_openBlock(), _createBlock(_component_base_divider, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              }), 64))
            ])
          ]),
          _: 1
        })
      ])
    ])),
    _createVNode(_unref(ImageModal), {
      modelValue: showImageModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showImageModal).value = $event)),
      images: imagesModal.value,
      title: "Коттеджный посёлок 'Негород Заневский'"
    }, null, 8, ["modelValue", "images"])
  ]))
}
}

})